import jQuery from "jquery";
import $ from "jquery";
import util from "./util";





function jqueryPlugins(){

    /**
     * TypeSelector
     */
    $.extend({
        selectType : function( options ){
            options = $.extend( {
                selectors	:	[''],
                values : [ ],
                changeCallback : null,
                url		:	'/utils/type.html?tid=#tid#&fid=#fid#&r=' + Math.random(),
                prepend : [],
                append : [],
                valueAsKey: false,
                notRenderValue : ['none' , 'other']
            },options);

            function render( el, fid, sKey, callback) {
                if (fid == null) {
                    fid = 0;
                }
                $.getJSON(options.url.replace(/#fid#/g, fid), function (res) {
                    if (res.errorCode != 0) {
                        return;
                    }
                    var data = res.msg, ret = [];
                    if ( typeof options.prepend[sKey] != 'undefined' && options.prepend[sKey].length > 0 ){
                        ret.push(`<option value="${options.prepend[sKey][0]}">${options.prepend[sKey][1]}</option>`);
                    }
                    var bindValue = typeof options.values[sKey] == 'undefined' ? '' : options.values[sKey];

                    for (var x in data) {
                        var ss = data[x].id == bindValue ? "selected" : "";
                        var val = options.valueAsKey ? data[x].typename : data[x].id;
                        ret.push(`<option ${ss} value="${val}">${data[x].typename}</option>`)
                    }


                    if ( typeof options.append[sKey] != 'undefined' && options.append[sKey].length > 0){
                        var ss = options.append[sKey][0] == bindValue ? "selected" : "";
                        ret.push(`<option ${ss} value="${options.append[sKey][0]}">${options.append[sKey][1]}</option>`);
                    }
                    var html = ret.join('');
                    $(el).html(html).trigger('change');
                    if (callback != undefined && typeof options.changeCallback == 'function') {
                        options.changeCallback(callback.father, callback.child, data);
                    }
                });
            }

            //bind change event for every element
            for(var x in options.selectors){
                (function( index ){
                    $(options.selectors[index]).change(function(){
                        var child = parseInt(index) + 1;

                        if ( typeof options.selectors[child] == 'undefined'){
                            return;
                        }

                        if ( options.notRenderValue.indexOf($(this).val()) > -1){
                            return;
                        }

                        var callback = {
                            father : options.selectors[index],
                            child : options.selectors[child]
                        };
                        render( options.selectors[child] , $(this).val(), child, callback);
                    });
                })( x );
            }

            render( options.selectors[0] , 0 , 0 );

        }
    });

    /**
     * select maker
     */
    $.fn.extend({
        makeSelectOptions : function( o ){

            var data = $.extend({
                dataList :  {}   ,
                prepend : [],       //set prepend values ； [ ['0','Desc Text'] , ['1' , 'None'] ]
                selected : 0 ,      //
                valueAsKey : false,     //
            } , o);
            var me = $(this);
            var tplOption = '';
            console.log(tplOption);
            if ( data.prepend.length > 0 ){
                for(var x in data.prepend){
                    tplOption += "<option value='"+ data.prepend[x][0]  + "'>" + data.prepend[x][1]  + "</option>";
                }
            }
            for( var x in data.dataList){
                var selected = "";
                selected = data.dataList[x] == data.selected ? "selected"  : "";

                var val = data.valueAsKey ? data.dataList[x] : x;
                tplOption += "<option "+selected+" value='"+val+"'>"+ data.dataList[x] +"</option>";
            }
            me.append( tplOption );
        }
    });

    /**
     * trigger contact button to show modal
     */
    $('body').delegate('.js-g-contact' , 'click' , function(){
        var data = decodeURIComponent($(this).attr('data-contact'));
        var obj = JSON.parse(data);
        var tpl = `<div class="contact-info">
                    <div class="name">
                        <i class="caricons icon-person-man-tie"></i>${obj.sellerName}
                    </div>
                    <div class="phone">
                        <i class="fa fa-phone-square"></i>${obj.phone}
                        <a href="tel:${obj.phone}" class="btn btn-info">
                            <i class="fa fa-phone"></i>
                            ${window.LANG.callNow}</a>
                    </div>
                </div>`;
        util.alert(tpl , LANG.contactTheSeller);
    });

}


export {
    jqueryPlugins
}


// WEBPACK FOOTER //
// ./src/lib/typeSelector.js